import './Footer.scss';

import cn from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import ButtonLoading from '@/common/components/molecules/ButtonLoading/ButtonLoading';

import { FooterDefaultProps, FooterPropTypes } from './Footer.proptypes';
import useFooter from './useFooter';

const Footer = ({ className, disabled, isLoading, onRemoveWarehouse }) => {
  const { t } = useTranslation();

  const { isDisabled } = useFooter({
    disabled,
    isLoading,
  });

  return (
    <div className={cn('scanbat-no-cart-footer', className)}>
      <ButtonLoading
        buttonSize="large"
        context="scanbat-logout"
        disabled={isDisabled.disabled}
        isLoading={isDisabled.loading}
        onClick={onRemoveWarehouse}
        variant="primary-light"
      >
        {t('common:messages:actions.logout')}
      </ButtonLoading>
    </div>
  );
};

Footer.defaultProps = {
  ...FooterDefaultProps,
};

Footer.propTypes = {
  ...FooterPropTypes,
};

export default Footer;
